import {
  ADMIN_SIDEBAR_NAV_GROUPS,
  getMuxMembershipDashboardItems,
  type AdminSidebarNavGroup,
  type AdminSidebarNavItem,
} from "@/components/admin/adminSidebarNav";

export interface AdminNavVisibilityOpts {
  isSuperAdmin: boolean;
  hidden: readonly string[];
  /**
   * Rol acotado `{ role: "admin", approved: true }`: solo ve items
   * `revenueMetrics`. Ver isPublicMetadataRevenueOnlyAdmin.
   */
  isRevenueOnlyAdmin?: boolean;
}

export function isAdminNavItemVisible(
  item: AdminSidebarNavItem,
  opts: AdminNavVisibilityOpts,
): boolean {
  // Revenue-only admin: SOLO métricas de ganancias, nada más (aunque el item
  // no sea superAdminOnly). Gana sobre el resto de reglas.
  if (opts.isRevenueOnlyAdmin) return item.revenueMetrics === true;
  if (item.superAdminOnly && !opts.isSuperAdmin) return false;
  if (opts.hidden.includes(item.to) && !opts.isSuperAdmin) return false;
  return true;
}

export function filterVisibleAdminNavGroups(
  opts: AdminNavVisibilityOpts,
): AdminSidebarNavGroup[] {
  return ADMIN_SIDEBAR_NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => isAdminNavItemVisible(item, opts)),
  })).filter((group) => group.items.length > 0);
}

export function getVisibleMuxMembershipDashboardItems(
  opts: AdminNavVisibilityOpts,
): AdminSidebarNavItem[] {
  return getMuxMembershipDashboardItems().filter((item) =>
    isAdminNavItemVisible(item, opts),
  );
}

/** Atajos rápidos del hub — primeros 4 módulos visibles del grupo Mux. */
export function getMuxMembershipQuickLinks(
  opts: AdminNavVisibilityOpts,
): AdminSidebarNavItem[] {
  return getVisibleMuxMembershipDashboardItems(opts).slice(0, 4);
}

/** Paths que un revenue-only admin puede abrir por URL directa. */
export const REVENUE_ONLY_ADMIN_ALLOWED_PATHS: readonly string[] = ["/admin/revenue"];

export const REVENUE_ONLY_ADMIN_HOME = "/admin/revenue";

export function isPathAllowedForRevenueOnlyAdmin(pathname: string): boolean {
  return REVENUE_ONLY_ADMIN_ALLOWED_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}